import { Linking, Platform } from "react-native";
import * as Clipboard from "expo-clipboard";

export const copyAddressToClipboard = async (address) => {
  if (!address) return false;

  try {
    await Clipboard.setStringAsync(address);
    return true;
  } catch {
    return false;
  }
};

export const openDirections = async ({ address, latitude, longitude, label }) => {
  let directionsUrl;

  if (latitude != null && longitude != null) {
    const latLng = `${latitude},${longitude}`;
    const encodedLabel = encodeURIComponent(label || "");
    directionsUrl = Platform.select({
      ios: `maps:0,0?q=${encodedLabel}@${latLng}`,
      android: `geo:0,0?q=${latLng}(${encodedLabel})`,
      default: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${label || ""} ${latLng}`.trim())}`,
    });
  } else if (address) {
    const encodedAddress = encodeURIComponent(address);
    directionsUrl = Platform.select({
      ios: `maps:0,0?q=${encodedAddress}`,
      android: `geo:0,0?q=${encodedAddress}`,
      default: `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`,
    });
  }

  if (!directionsUrl) return false;

  try {
    await Linking.openURL(directionsUrl);
    return true;
  } catch {
    return false;
  }
};
